import type { SensorData } from '../types';

const CACHE_TTL_MS = 5 * 60 * 1000;

interface CacheEntry {
  data: SensorData[];
  total: number;
  fetchedAt: number;
}

const cache = new Map<string, CacheEntry>();

export function buildSensorDataCacheKey(
  ensayoId: string,
  sensorId: string,
  maxPoints: number,
  movingAverageWindow: number | null | undefined,
  useAdjustedTimestamps: boolean | undefined
): string {
  return [
    ensayoId,
    sensorId,
    maxPoints,
    movingAverageWindow ?? '',
    useAdjustedTimestamps ? '1' : '0',
  ].join(':');
}

export function getCachedSensorData(key: string): SensorData[] | null {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > CACHE_TTL_MS) {
    cache.delete(key);
    return null;
  }
  return entry.data;
}

export function setCachedSensorData(key: string, data: SensorData[], total: number): void {
  cache.set(key, { data, total, fetchedAt: Date.now() });
}

export function invalidateEnsayoSensorCache(ensayoId: string): void {
  for (const key of cache.keys()) {
    if (key.startsWith(`${ensayoId}:`)) {
      cache.delete(key);
    }
  }
}
